export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const TOGGLE_ME_SETTING = 'TOGGLE_ME_SETTING';
export const TOGGLE_CLIPPING_PANEL = 'TOGGLE_CLIPPING_PANEL';

export const toggleSidebar = (data) => ({
  type: TOGGLE_SIDEBAR,
  data
});

export const toggleMeSetting = (data) => ({
  type: TOGGLE_ME_SETTING,
  data
});

export const toggleClippingPanel = (data) => ({
  type: TOGGLE_CLIPPING_PANEL,
  data
});




/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/actions.js
 **/